<template>
  <div class="cropper-img">
    <el-dialog
        title="修改头像"
        :visible.sync="isShowImgPop"
        append-to-body
        width="700px"
        center
    >
      <Cropper
          :initialImg="head"
          @close="isShowImgPop = false"
          @finish="handleFinish"
      >
      </Cropper>
    </el-dialog>
    <div @click="handleOpen" class="cropper-img-item">
      <slot></slot>
    </div>
  </div>
</template>
<script>
import Cropper from "./cropper";

export default {
  name: "login",
  /**
   * 调用组建
   * @type {Object}
   */
  components: {Cropper},
  /**
   * 组建属性
   * @type {Object}
   */
  props: {},
  /**
   * 数据字段
   * @return {[type]} [description]
   */
  data() {
    return {
      isShowImgPop: false,
      head: ""
    };
  },
  /**
   * 计算属性
   * @type {Object}
   */
  computed: {},
  /**
   * 数据监听
   * @type {Object}
   */
  watch: {},
  /**
   * 页面创建时
   * @return {[type]} [description]
   */
  created() {

  },
  /**
   * 页面加载时
   * @return {[type]} [description]
   */
  mounted() {

  },
  /**
   * 页面调用函数
   * @type {Object}
   */
  methods: {
    handleOpen() {
      this.isShowImgPop = true
    },
    handleFinish({data, close}) {
      this.$emit("finish", {data, close})
    }
  }
};
</script>
<style>
.cropper-img, .cropper-img-item {
  display: inline-block;
}
</style>